import { ref, type Ref } from "vue";

type Timer = ReturnType<typeof setTimeout>;

export const useCanceledTimeout = () => {
  const timer = ref<Timer | null>(null);
  const canceled = ref<boolean>(false);

  const createTimeout = (fun: ((canceled: Ref<boolean>) => void | Promise<void>), time: number) => {
    if (timer.value !== null) {
      clearTimeout(timer.value);
      timer.value = null;
    }
    canceled.value = false;
    timer.value = setTimeout(() => fun(canceled), time);
  }

  const cancel = () => {
    canceled.value = true;
    if (timer.value === null) return;
    clearTimeout(timer.value);
  }

  return {
    setTimeout: createTimeout,
    cancel: cancel
  }
}
